import {isUuid} from "../../../libs/utils/epic.utils";

export class VehicleDto {

  public id!: string;
  // A: Amtliches Kennzeichen
  public licensePlate: string | undefined;
  // 2.1: KBA-Nummer 1 / Herstellerschluesselnummer (HSN)
  public manufacturerCodeNumber: string | undefined;
  // 2.2: KBA-Nummer 2 / Typschluesselnummer (TSN)
  public typeCodeNumber: string | undefined;
  // 2.2: KBA-Nummer 3 / Volumenschluesselnummer (VSN)
  public volumeKeyNumber: string | undefined;
  // Type Approval / Typengenehmigung (TG / Typenschein-Nr.) üblich in CH
  public typeApproval: string | undefined;
  // Registration Number / Stammnummer üblich in CH
  public registrationNumber: string | undefined;
  // E: Fahrzeug-Identifizierungsnummer (Fahrgestellnummer) / FIN / vehicle identification number
  public vin: string | undefined;
  // B: Datum der Erstzulassung des Fahrzeugs
  public firstRegistration: Date | undefined;
  // P.2: Nennleistung in kW / Nominal Performance in kW
  public performanceInKw: number | undefined;
  // 6: Datum zu Nummer der EG-Typengenehmigung oder ABR (Allgemeine Betriebserlaubnis)
  // The year of construction and the complete date can be entered
  // Format "dd.MM.yyyy" or "MM.yyyy" or "yyyy"
  public constructionDate: string | undefined;
  // P.1: Hubraum in ccm3
  public displacementInCcm: number | undefined;
  public engineCode: string | undefined;
  // Farbcode / Farbnummer / Lacknummer / Lackcode
  public colorCode: string | undefined;
  public nextTechnicalInspection: Date | undefined;
  public nextEmissionsTest: Date | undefined;
  public nextCustomerService: Date | undefined;
  public nextTireChange: Date | undefined;
  public notes: string | undefined;
  // UUID (exists) or String (new)
  public engine: string | undefined;
  public readonly engineName: string | undefined;
  // UUID (exists) or String (new)
  public type: string | undefined;
  public readonly typeName: string | undefined;
  // UUID (exists) or String (new)
  public manufacturer: string | undefined;
  public readonly manufacturerName: string | undefined;
  // UUID (exists) or String (new)
  public model: string | undefined;
  public readonly modelName: string | undefined;
  // UUID (exists) or String (new)
  public variant: string | undefined;
  public readonly variantName: string | undefined;
  public readonly contactFullName: string | undefined;
  public readonly externalId: string | undefined;
  public readonly inspectionNotificationCorrespondenceId: string | undefined;
  public readonly tireChangeCorrespondenceId: string | undefined;
  public nextInspection: Date | undefined;

  constructor(init?: Partial<VehicleDto> | undefined) {
    Object.assign(this, init);
    if (init?.firstRegistration) {
      this.firstRegistration = new Date(init.firstRegistration);
    }
    if (init?.nextTechnicalInspection) {
      this.nextTechnicalInspection = new Date(init.nextTechnicalInspection);
    }
    if (init?.nextEmissionsTest) {
      this.nextEmissionsTest = new Date(init.nextEmissionsTest);
    }
    if (init?.nextCustomerService) {
      this.nextCustomerService = new Date(init.nextCustomerService);
    }
    if (init?.nextTireChange) {
      this.nextTireChange = new Date(init.nextTireChange);
    }
    if (init?.nextInspection) {
      this.nextInspection = new Date(init.nextInspection);
    }
  }

  public isEditable(): boolean {
    return true;
  }

  // noinspection JSUnusedGlobalSymbols / used in List
  public hasInspectionNotificationCorrespondenceId(): boolean {
    return isUuid(this.inspectionNotificationCorrespondenceId);
  }

  // noinspection JSUnusedGlobalSymbols / used in List
  public hasTireChangeCorrespondenceId(): boolean {
    return isUuid(this.tireChangeCorrespondenceId);
  }
}
